import React, { useEffect, useState } from 'react';
import heic2any from 'heic2any';
import { Typography } from '@mui/material';
import { LoadingEvent } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';

async function convertHeicUrlToJpeg(url) {
  try {
    // Fetch the HEIC file as a blob
    const response = await fetch(url);
    const heicBlob = await response.blob();

    // Convert to JPEG blob
    const jpegBlob = await heic2any({ blob: heicBlob, toType: 'image/jpeg' });

    // Create a URL to use in <img>
    return {
      data: URL.createObjectURL(jpegBlob),
      error: null,
    };
  } catch (err) {
    return {
      data: null,
      error: err.message,
    };
  }
}

function ImageViewer({ imageUrl, fileType = 'jpg' }) {
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(null);
  const [dataAsUrlOrBlob, setDataAsUrlOrBlob] = useState(imageUrl);

  const initialize = async () => {
    setLoading(true);
    if (fileType === 'heic') {
      const heicConverted = await convertHeicUrlToJpeg(imageUrl);
      if (heicConverted.error) {
        setHasError(heicConverted.error);
      } else {
        setDataAsUrlOrBlob(heicConverted.data);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, [imageUrl, fileType]);

  if (loading) {
    <LoadingEvent>
      <FormattedMessage id="PROCESSING" defaultMessage="Processing" />
      ...
    </LoadingEvent>;
  }

  return (
    <div style={{ width: '100%' }}>
      {hasError ? (
        <Typography>{hasError}</Typography>
      ) : (
        <img src={dataAsUrlOrBlob} alt="Viewer" />
      )}
    </div>
  );
}

export default ImageViewer;
